export default {
  GET_AUTH: (state) => state.auth,
  GET_USER: (state) => state.auth.user,
  GET_USER_TYPE: (state) => state.user_type,
  GET_ERR: (state) => state.err,
  GET_ROLE: (state) => state.role,
  GET_ROLES: (state) => state.roles,
};
